import { Upload } from '@phosphor-icons/react';

export default Upload;
